// extracted by mini-css-extract-plugin
export default {"container":"Preloader_container__auXDr","containerInline":"Preloader_containerInline__zid+E","preloader":"Preloader_preloader__yp2SU","rotation":"Preloader_rotation__ibUNA"};